import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, errorMessage } from "@/lib/api";
import { AuthShell, FormError, PASSWORD_HINT } from "@/components/auth/AuthShell";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (pw !== pw2) return setError("As senhas não são iguais.");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password: pw });
      setDone(true);
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <AuthShell title="Senha alterada" testid="reset-page">
        <div className="space-y-4" data-testid="reset-done">
          <p className="flex gap-2 text-sm text-emerald-200"><CheckCircle2 className="h-5 w-5 shrink-0" /> Pronto! Use a nova senha para entrar. Por segurança, as sessões abertas em outros aparelhos foram encerradas.</p>
          <Button asChild className="h-11 w-full rounded-full font-semibold"><Link to="/login" data-testid="reset-go-login">Entrar</Link></Button>
        </div>
      </AuthShell>
    );
  }

  return (
    <AuthShell title="Criar nova senha" subtitle={PASSWORD_HINT} testid="reset-page">
      {!token ? <FormError error="Link incompleto. Abra o link do e-mail novamente ou peça um novo." /> : (
        <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
          <div className="space-y-1.5">
            <Label htmlFor="rp_pw">Nova senha</Label>
            <Input id="rp_pw" type="password" required autoComplete="new-password" value={pw} onChange={(e) => setPw(e.target.value)} className="h-11 bg-slate-950" data-testid="reset-password-input" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="rp_pw2">Repita a nova senha</Label>
            <Input id="rp_pw2" type="password" required autoComplete="new-password" value={pw2} onChange={(e) => setPw2(e.target.value)} className="h-11 bg-slate-950" data-testid="reset-password-confirm-input" />
          </div>
          <FormError error={error} />
          <Button type="submit" disabled={loading} className="h-11 w-full rounded-full font-semibold" data-testid="reset-submit-button">
            {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Salvar nova senha
          </Button>
        </form>
      )}
      <p className="mt-4 text-center text-sm"><Link to="/esqueci-senha" className="text-slate-400 underline" data-testid="reset-new-link">Pedir um novo link</Link></p>
    </AuthShell>
  );
}
